import { AnchorHTMLAttributes, useEffect, useState } from 'react'

import styled from '@emotion/styled'
import { useTranslation } from 'react-i18next'

import { Button } from '@cash-design-system/react'
import logger from '@cash-web/shared/util-logger'
import * as fetchUtils from '@cash-web/shared-util-fetch'

import { STATUS_PAGE_API_URL, STATUS_PAGE_URL } from '../../status-page-urls'

const Container = styled.a`
  text-decoration: none;
`

interface Component {
  status: string
}

interface StatusPageResponse {
  components?: Component[]
}

type Props = AnchorHTMLAttributes<HTMLAnchorElement>

function CheckStatusPageButton({ ...props }: Props) {
  const [issueDetected, setIssueDetected] = useState(false)
  const { t } = useTranslation()

  useEffect(() => {
    fetchUtils.get<StatusPageResponse>(STATUS_PAGE_API_URL).then(response => {
      logger.addBreadcrumb('StatusPageResponse', { response })

      if (!response.components) {
        setIssueDetected(true)
      } else {
        const nonOperationalComponents = response.components.filter(component => component.status !== 'operational')
        if (nonOperationalComponents.length > 0) {
          setIssueDetected(true)
        }
      }
    })
  }, [])

  if (!issueDetected) {
    return null
  }

  return (
    <Container role="link" target="_blank" rel="noreferrer" href={STATUS_PAGE_URL} {...props}>
      <Button size="large" variant="secondary">
        {t('Is Cash App Working?', { context: 'Title of the check status page button' })}
      </Button>
    </Container>
  )
}

export default CheckStatusPageButton
